import {useState, useEffect} from "react";
import {getDeliveryFlowOverview} from "../../../util/request";
import {useCustomer} from "../../../layouts/SelfcareLayout";
import DeliveryFlow from "./DeliveryFlow";
import {ScrollToAnchorPoint} from "../../../util/ScrollToAnchor";
import LoaderSpinner from "../../loaders/LoaderSpinner";

export default function DeliveryFlowList() {
    const {customer} = useCustomer();
    const [deliveryFlowIds, setDeliveryFlowIds] = useState<number[]>([]);
    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        getDeliveryFlowOverview(customer.customer_id)
            .then(r => setDeliveryFlowIds(r.response.data.reverse().map(timeline => timeline.workflow_instance_id)))
            .catch(() => {})
            .finally(() => setLoading(false))
    }, [customer.customer_id]);

    if (loading) {
        return <LoaderSpinner/>
    }

    if (deliveryFlowIds.length === 0) {
        return null;
    }

    return <>
        <hr/>
        <ScrollToAnchorPoint id="installationsforloeb" className="id-anchor--selfcare"/>
        <div className="selfcare-page-content selfcare-page-content--full selfcare-page-delivery-flow">
            <div className="selfcare-page-summary">
                <h2 className="heading heading--big">Installationsforløb</h2>
                <p>Følg din bestilling trin for trin og se alle relevante beskeder undervejs.</p>
            </div>
            {deliveryFlowIds.map((deliveryFlowId, index) =>
                <DeliveryFlow
                    key={index}
                    id={deliveryFlowId}
                    withDivider={index !== deliveryFlowIds.length - 1}
                />
            )}
        </div>
    </>
}

